import { Component, EventEmitter, Input, Output } from '@angular/core';
import { validateResidue } from '../nightingale.helpers';

@Component({
  selector: 'app-zoom-annotations',
  templateUrl: './zoom-annotations.component.html',
  styleUrl: './zoom-annotations.component.css',
  standalone: false
})
export class ZoomAnnotationsComponent {
  start = '';
  end = '';

  startErrors: string[] = [];
  endErrors: string[] = [];
  
  @Input() sequenceLength: number;
  @Output() closeDialog = new EventEmitter<void>();
  @Output() zoomAnnotations: EventEmitter<Object> = new EventEmitter();

  // Called live when typing residue ranges
  onResidueInput(inputType: 'start' | 'end') {
    if (inputType === 'start') {
      const { isValidStart, messagesStart } = this.validateStart();
      this.startErrors = isValidStart ? [] : messagesStart;
    }
    if (inputType === 'end') {
      const { isValidEnd, messagesEnd } = this.validateEnd();
      if (this.end.length > 0) this.endErrors = isValidEnd ? [] : messagesEnd;
      else this.endErrors = [];
    }
  }

  validateStart() {
    const { isValid, messages } = validateResidue({ start: 1, end: this.sequenceLength }, this.start);
    return {isValidStart: isValid, messagesStart: messages};
  }

  validateEnd() {
    const { isValid, messages } = validateResidue({ start: 1, end: this.sequenceLength }, this.end);
    return {isValidEnd: isValid, messagesEnd: messages};
  }
  
  onClose() {
    this.closeDialog.emit();
  }

  onZoom(type){
    const { isValidStart, messagesStart } = this.validateStart();
    let isValidEnd = true;
    let messagesEnd: string[] = [];

    // Only validate "end" if it was actually filled
    if (this.end.trim() !== '') {
      const result = this.validateEnd();
      isValidEnd = result.isValidEnd;
      messagesEnd = result.messagesEnd;
    }
    this.startErrors = isValidStart ? [] : messagesStart;
    this.endErrors = isValidEnd ? [] : messagesEnd;
    if (isValidStart && isValidEnd) {
      const startVal = Number(this.start);
      const endVal = this.end.trim() === '' ? startVal : Number(this.end);
      this.zoomAnnotations.emit({type:type, start: startVal, end: endVal});
    }
  }
}
